import { useEffect, useState } from "react";
import { Loading } from "../../components/Loading";
import SimplePagination from "../../components/SimplePagination";
import { SchoolAdminQueryModel, useSchoolAdminsListQuery } from "./schoolsApiSlice";
import SchoolAdminsTable from "./SchoolAdminsTable";

interface SchoolAdminsProps {
	schoolId: number;
}

export default function SchoolAdminsSection(props: SchoolAdminsProps) {
	const _displayLength = 5;
	const initQueryargs: SchoolAdminQueryModel = {
		iDisplayStart: 0,
		iDisplayLength: _displayLength,
		iSortCol_0: 0,
		sSortDir_0: "desc",
		schoolId: props.schoolId,
	};

	const [queryargs, setQueryargs] = useState(initQueryargs);
	const [page, setPage] = useState(0);

	const schoolAdminsResult = useSchoolAdminsListQuery(queryargs);
	const schoolAdmins = schoolAdminsResult.data;

	useEffect(() => {
		setQueryargs({
			...queryargs,
			iDisplayStart: _displayLength * page,
		});
	}, [page]);

	const handlePageChange = (page: number) => {
		setPage(page);
	};

	return (
		<section>
			<hr className="my-6" />
			<h2>School Admins</h2>
			<Loading loading={schoolAdminsResult.isLoading} />
			{schoolAdmins && <SchoolAdminsTable admins={schoolAdmins.aaData} />}
			<SimplePagination
				itemCount={schoolAdmins?.iTotalDisplayRecords}
				page={page}
				pageSize={queryargs.iDisplayLength}
				totalCount={schoolAdmins?.iTotalRecords}
				onChange={(page) => handlePageChange(page)}
				className={"border-none"}
			/>
		</section>
	);
}
